import React from 'react';
import { Form } from 'react-bootstrap';
import { useContentPage } from '../context/ContentPageContext';
import Column from './Column';

const Section = ({ section }) => {
  const { addColumn, removeSection, updateSectionHeadings } = useContentPage();

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="card-title mb-0">Section</h5>
            <div>
              <button
                className="btn btn-primary btn-sm me-2"
                onClick={() => addColumn(section.id)}
                disabled={section.columns.length >= 3}
                title="Add column (max 3)"
                type="button"
              >
                <i className="bi bi-plus-circle me-1"></i> Add Column
              </button>
              <button
                className="btn btn-danger btn-sm"
                onClick={() => removeSection(section.id)}
                title="Remove section"
                type="button"
              >
                <i className="bi bi-trash"></i>
              </button>
            </div>
          </div>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-12">
                <Form.Group className="mb-3">
                  <Form.Label>Section Heading</Form.Label>
                  <Form.Control
                    type="text"
                    value={section.heading || ''}
                    onChange={(e) => updateSectionHeadings(section.id, { heading: e.target.value })}
                    placeholder="Enter section heading (optional)"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Section Subheading</Form.Label>
                  <Form.Control
                    type="text"
                    value={section.subheading || ''}
                    onChange={(e) => updateSectionHeadings(section.id, { subheading: e.target.value })}
                    placeholder="Enter section subheading (optional)"
                  />
                </Form.Group>
              </div>
            </div>
            <div className="row">
              {section.columns.map((column, index) => (
                <div
                  key={column.id}
                  className="col-xl-6 col-lg-6 mb-3"
                >
                  <Column
                    column={column}
                    sectionId={section.id}
                    canRemove={section.columns.length > 1}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section;
